import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  Button,
  CardActionArea,
  // CircularProgress,
} from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import {
  productsCollection,
  useData,
} from "../../../components/firebase/DataProvider";
import {
  analytics,
  FieldValue,
} from "../../../components/firebase/FirebaseProvider";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  arrayToCurrencyStringKomisi,
  calculateHargaLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import Gap from "../../../components/atoms/Gap";
import Header from "../../../components/molecules/Header";
import useStyles from "./styles";
import { useLocation, useHistory } from "react-router-dom";
import slugify from "slugify";
// import InfiniteScroll from "react-infinite-scroll-component";
import { upperFirst } from "lodash";
import { useSnackbar } from "notistack";
import CopyToClipboard from "react-copy-to-clipboard";
import SkeletonProduct from "../../../components/atoms/SkeletonProduct";

const CardProduct = ({
  item,
  index,
  toDetailProduct,
  promoF,
  emptyStock,
  textBadgePromo,
  total_stok,
  productValue,
  harga_normal,
  promoFound,
  harga_str_promo,
  harga_str,
  domain,
  bagikan,
}) => {
  const classes = useStyles();
  const { level, promo, global_komisi } = useData();

  const [newArrival, setNewArrival] = useState(false);

  useEffect(() => {
    const time = new Date();
    const timeSeconds = Math.round(time.getTime() / 1000);
    const timeNewArrival = item?.new_arrival?.seconds;
    const expiredTime = timeNewArrival - timeSeconds;
    if (expiredTime > 0) {
      setNewArrival(true);
    } else {
      setNewArrival(false);
    }
  }, []);

  const lowestPrice = Math.round(Math.min(...harga_normal));

  const all_komisi_str = arrayToCurrencyStringKomisi(
    lowestPrice,
    level.level,
    promoFound,
    global_komisi,
    productValue
  );

  return (
    <div className={classes.wrapper} key={index}>
      <Card className={classes.card}>
        <CardActionArea onClick={toDetailProduct(item.id, item.nama)}>
          {promoF && !emptyStock ? (
            <div className={classes.label}>
              <Typography className={classes.txtLabel}>
                {textBadgePromo}
              </Typography>
              <Typography className={classes.txtLabel}>OFF</Typography>
            </div>
          ) : null}

          {emptyStock ? (
            <div className={classes.empty}>
              <span className={classes.txtEmpty}>Stok Habis</span>
            </div>
          ) : null}
          {item.thumbnail?.length > 0 ? (
            <div
              loading="lazy"
              // src={item.thumbnail[0]}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail[0]})`,
              }}
            />
          ) : (
            <div
              loading="lazy"
              // src={item.thumbnail}
              // alt={item.id}
              className={classes.img}
              style={{
                backgroundImage: `url(${item.thumbnail})`,
              }}
            />
          )}
        </CardActionArea>
        <div className={classes.contentWrapper}>
          <div className={classes.content}>
            <div style={{ display: "flex", marginBottom: 5 }}>
              {promoFound?.flash_sale || promoFound?.special_offer ? (
                <div className={classes.labelFlash}>
                  {promoFound?.flash_sale ? "Flashsale" : "Special Offer"}
                </div>
              ) : null}
              {item?.properties?.type === "preorder" &&
              item?.properties.end_at?.seconds * 1000 > Date.now() ? (
                <div className={classes.labelPre}>Pre Order</div>
              ) : null}
              {newArrival && <div className={classes.labelNew}>Baru</div>}
            </div>
            <Typography className={classes.title} noWrap component="p">
              {item?.nama}
            </Typography>
            <Typography className={classes.txtStockTersedia} component="p">
              Stok tersedia
            </Typography>
            <Typography className={classes.txtStock} component="p">
              {total_stok > 100 ? "99+" : total_stok} pcs
            </Typography>
            <Typography className={classes.txtLabelharhag} component="p">
              Harga {upperFirst(level.level)}
            </Typography>
            {promo && (
              <Typography className={classes.price} component="p">
                {promoFound ? harga_str_promo : harga_str}
              </Typography>
            )}
            <div className={classes.labelKomisi}>
              {all_komisi_str} {" "}
              Komisi
            </div>
            {/* {newArrival && (
              <div style={{ position: "absolute", right: 0, zIndex: "0" }}>
                <NewFeatureIcon width={32} height={32} />
              </div>
            )} */}
          </div>

          <div className={classes.btnWrap}>
            {emptyStock ? (
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                size="small"
                className={classes.btn}
                style={{
                  backgroundColor: "rgb(255, 107, 107)",
                }}
              >
                Stok Habis
              </Button>
            ) : (
              <CopyToClipboard
                text={`${domain}/produk/${slugify(item.nama.toLowerCase())}/${
                  item.product_id
                }`}
                onCopy={bagikan(item)}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes.btn}
                  endIcon={<ShareIcon />}
                >
                  Bagikan
                </Button>
              </CopyToClipboard>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

// const LIMIT = 6;
export default function Index() {
  const classes = useStyles();
  // const history = useHistory();
  const location = useLocation();
  const history = useHistory();
  const nilai = location?.pathname.split("/");

  // console.log("ini nilai", nilai)
  const lastVisible = React.useRef();
  const { level, promo, webstore, webstoreRef, global_komisi, preorderUtils } = useData();
  const [products, setProducts] = React.useState([]);
  const [productsKosong, setProductsKosong] = React.useState([]);
  const [productCounts, setProductCounts] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  // const [loadingMore, setLoadingMore] = React.useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const domain = `https://${webstore.domain}.tokorame.store`;

  useEffect(() => {
    // if (!nilai[1] || !nilai[2] || !nilai[3] || !nilai[4]) {
    //   history.push('/kategori')
    // } else {

    async function getProducts() {
      setLoading(true);
      setProducts([]);
      // limit 2 products in
      try {
        const query = await productsCollection
          .where(`${nilai[2]}.id`, "==", nilai[4])
          .where("sembunyikan_produk", "==", false)
          .orderBy("created_at", "desc")
          // .orderBy("sorting_number")
          // .limit(12)
          .get();
        if (!query.empty) {
          const newProducts = await Promise.all(
            query.docs.map(async (product) => {
              const variants = await product.ref
                .collection("variants")
                .where(`harga_normal`, ">", 0)
                .get();
              return {
                id: product.id,
                ...product.data(),
                variants: variants.docs.map((variant) => {
                  return {
                    id: variant.id,
                    ...variant.data(),
                  };
                }),
              };
            })
          );
          const filteredProducts = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            return product.variants.length > 0 && total_stok > 0;
          });
          setProducts((products) => [...products, ...filteredProducts]);
          const filteredProductsKosong = newProducts.filter((product) => {
            const stok = product?.variants?.map(
              (variant) => variant?.stok_available
            );
            const total_stok = stok?.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);
            return product.variants.length > 0 && total_stok <= 0;
          });

          setProductsKosong((productsKosong) => [
            ...productsKosong,
            ...filteredProductsKosong,
          ]);
          lastVisible.current = query.docs[query.docs.length - 1];
        }

        productsCollection
          .where(`${nilai[2]}.id`, "==", nilai[4])
          .where("sembunyikan_produk", "==", false)
          .get()
          .then(function (as) {
            setProductCounts(as.size);
          });
        // console.log(productCount);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    }
    getProducts();
    // }
  }, [location]);
  // console.log(productCounts);

  // const loadMoreProducts = async () => {
  //   // console.log("jalan");
  //   if (lastVisible.current && loadingMore) {
  //     setLoadingMore(true);
  //     try {
  //       const productsRef = productsCollection;
  //       const query = await productsRef
  //         .where(`${nilai[2]}.id`, "==", nilai[4])
  //         .where("sembunyikan_produk", "==", false)
  //         .orderBy("created_at", "desc")
  //         // .orderBy("sorting_number")
  //         .startAfter(lastVisible.current)
  //         .limit(12)
  //         .get();
  //       if (!query.empty) {
  //         const newProducts = await Promise.all(
  //           query.docs.map(async (product) => {
  //             const variants = await product.ref
  //               .collection("variants")
  //               .where(`harga_normal`, ">", 0)
  //               .get();
  //             return {
  //               id: product.id,
  //               ...product.data(),
  //               variants: variants.docs.map((variant) => {
  //                 return {
  //                   id: variant.id,
  //                   ...variant.data(),
  //                 };
  //               }),
  //             };
  //           })
  //         );

  //         const filteredProducts = newProducts.filter(
  //           (product) => product.variants.length > 0
  //         );
  //         setProducts((products) => [...products, ...filteredProducts]);

  //         lastVisible.current = query.docs[query.docs.length - 1];
  //       } else {
  //         lastVisible.current = null;
  //         setLoadingMore(false);
  //       }
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   }
  // };

  // console.log(products);
  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  const bagikan = (data) => async () => {
    // setCopied(true);
    // console.log(data);
    const findProductId = webstore.products?.includes?.(data.id);
    const checkDownpayment =
      preorderUtils?.down_payment_products?.includes(data.id);
    const downPaymentStatus =
      checkDownpayment && preorderUtils?.down_payment_option;
    // console.log(findProductId);

    if (!findProductId && !downPaymentStatus) {
      await webstoreRef.set(
        {
          products: FieldValue.arrayUnion(data.id),
        },
        { merge: true }
      );
    }

    enqueueSnackbar("Link di salin", { variant: "success" });
  };

  return (
    <>
      <Header
        title={nilai[3] + ` (${productCounts})`}
        type="with-search-cart"
      />
      <Gap height={55} />
      {loading ? (
        <SkeletonProduct />
      ) : //  </InfiniteScroll>
      !loading && products.length !== 0 ? (
        <Grid container className={classes.root}>
          {products.map((item, index) => {
            const stok = item.variants.map((variant) => variant.stok_available);

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item.variants.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            const textBadgePromo = (() => {
              let text = "";

              if (promoFound) {
                if (promoFound?.tipe === "%") {
                  text = `${promoFound?.nilai}%`;
                } else {
                  text = `${promoFound?.nilai / 1000}K`;
                }
              }

              return text;
            })();

            return (
              <CardProduct
                item={item}
                index={index}
                toDetailProduct={toDetailProduct}
                textBadgePromo={textBadgePromo}
                productValue={productValue}
                harga_normal={harga_normal}
                bagikan={bagikan}
                promoFound={promoFound}
                promoF={promoF}
                harga_str_promo={harga_str_promo}
                harga_str={harga_str}
                domain={domain}
                total_stok={total_stok}
                emptyStock={emptyStock}
              />
            );
          })}
          {productsKosong.map((item, index) => {
            const stok = item.variants.map((variant) => variant.stok_available);

            const productValue =
              item?.product_value !== undefined &&
              item?.product_value !== "" &&
              !Number.isNaN(item?.product_value) &&
              item?.product_value >= 0
                ? item?.product_value
                : 1;

            const harga = item.variants.map((variant) =>
              calculateHargaLevel(
                variant?.harga_normal,
                global_komisi,
                level?.level,
                productValue
              )
            );

            const harga_normal = item.variants.map(
              (variant) => variant?.harga_normal
            );

            const promoFound = findOnePromo(item, promo);

            const total_stok = stok.reduce((val, nilaiSekarang) => {
              return val + nilaiSekarang;
            }, 0);

            const emptyStock = total_stok === 0 ? true : false;

            const harga_str = arrayToCurrencyString(harga);
            const promoF = promoFound ? true : false;

            const harga_str_promo =
              promoFound &&
              arrayToCurrencyStringPromo(
                harga_normal,
                promoFound,
                level.level,
                global_komisi,
                productValue
              );

            const textBadgePromo = (() => {
              let text = "";

              if (promoFound) {
                if (promoFound?.tipe === "%") {
                  text = `${promoFound?.nilai}%`;
                } else {
                  text = `${promoFound?.nilai / 1000}K`;
                }
              }

              return text;
            })();

            return (
              <>
                <div className={classes.wrapper} key={index}>
                  <Card className={classes.card}>
                    <CardActionArea
                      onClick={toDetailProduct(item.id, item.nama)}
                    >
                      {promoF && !emptyStock ? (
                        <div className={classes.label}>
                          <Typography className={classes.txtLabel}>
                            {textBadgePromo}
                          </Typography>
                          <Typography className={classes.txtLabel}>
                            OFF
                          </Typography>
                        </div>
                      ) : null}

                      {emptyStock ? (
                        <div className={classes.empty}>
                          <span className={classes.txtEmpty}>Stok Habis</span>
                        </div>
                      ) : null}
                      {item.thumbnail?.length > 0 ? (
                        <div
                          loading="lazy"
                          // src={item.thumbnail[0]}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item.thumbnail[0]})`,
                          }}
                        />
                      ) : (
                        <div
                          loading="lazy"
                          // src={item.thumbnail}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item.thumbnail})`,
                          }}
                        />
                      )}
                    </CardActionArea>
                    <div className={classes.contentWrapper}>
                      <div className={classes.content}>
                        <Typography
                          className={classes.title}
                          noWrap
                          component="p"
                        >
                          {item?.nama}
                        </Typography>
                        <Typography
                          className={classes.txtStockTersedia}
                          component="p"
                        >
                          Stok tersedia
                        </Typography>
                        <Typography className={classes.txtStock} component="p">
                          {total_stok > 100 ? "99+" : total_stok} pcs
                        </Typography>
                        <Typography
                          className={classes.txtLabelharhag}
                          component="p"
                        >
                          Harga {upperFirst(level.level)}
                        </Typography>
                        {promo && (
                          <Typography className={classes.price} component="p">
                            {promoFound ? harga_str_promo : harga_str}
                          </Typography>
                        )}
                        <div className={classes.labelKomisi}>
                          {Math.round(
                            global_komisi?.[level?.level] * productValue * 100
                          )}
                          % Komisi
                        </div>
                        {/* {newArrival && (
                          <div
                            style={{
                              position: "absolute",
                              right: 0,
                              zIndex: "0",
                            }}
                          >
                            <NewFeatureIcon width={32} height={32} />
                          </div>
                        )} */}
                      </div>

                      <div className={classes.btnWrap}>
                        {emptyStock ? (
                          <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.btn}
                            style={{
                              backgroundColor: "rgb(255, 107, 107)",
                            }}
                          >
                            Stok Habis
                          </Button>
                        ) : (
                          <CopyToClipboard
                            text={`${domain}/produk/${slugify(
                              item.nama.toLowerCase()
                            )}/${item.product_id}`}
                            onCopy={bagikan(item)}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              color="primary"
                              size="small"
                              className={classes.btn}
                              endIcon={<ShareIcon />}
                            >
                              Bagikan
                            </Button>
                          </CopyToClipboard>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              </>
            );
          })}
        </Grid>
      ) : !loading && products.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            width: "100%",
            marginTop: "25%",
          }}
        >
          <p>
            <b>Produk Tidak Ditemukan</b>
          </p>
        </div>
      ) : null}
    </>
  );
}
